import React         from 'react';
import ReactDom      from 'react-dom';
import Moment        from 'moment';

import Const         from 'fw_const';
import Utils         from 'utils';

import Sortable      from 'react-sortablejs' ;
import ContentsModal from 'contents_modal';

import SearchCommon  from '@common/influencer-search/_influencer-search';
// -------------------------------------------------------

class SearchCommonModal extends React.Component {
  render() {
    let data = this.props.data;
    if( data == undefined ) data = {};
    
    let base = this.props.base;
    
    // 候補者数・ストック数の取得
    let candidate_count = null;
    let candidate_followers_count = 0;
    
    let stock_count = null;
    let stock_followers_count = 0;
    
    try {
      candidate_count = base.workflow.items.candidate.length;
      base.workflow.items.candidate.map((d) => { if( d.influencer.followers != undefined ) candidate_followers_count += d.influencer.followers; });
    } catch(e) {}
    try {
      stock_count = base.workflow.items.stock.length;
      base.workflow.items.stock.map((d) => { if( d.influencer.followers != undefined ) stock_followers_count += d.influencer.followers; });
    } catch(e) {}
    
    return (
      <div className="influencer-search-modal">
        <ContentsModal
          view      = {this.props.view}
          width     = {'calc(100% - 80px)'}
          height    = {'calc(100% - 80px)'}
          max_width = {1240}
          //close_ev  = {this.props.close_ev.bind(this, false)}
          html      = {
            <div className="modal-item">
              <div className="influencer-search-modal-header">
                <p className="prev-button" onClick={this.props.close_ev.bind(this, false)}><i className="material-icons">chevron_left</i>戻る</p>
              </div>
              
              <SearchCommon base={base} />
              
              { (candidate_count != null) &&
                <div className="candidate-count">
                  <h6>候補者数</h6>
                  <p className="count">{Utils.viewInt(candidate_count)}<span>人</span></p>
                  
                  <h6>フォロワー総数</h6>
                  <p className="followers-count">({Utils.viewInt(candidate_followers_count)}<span>人</span>)</p>
                </div>
              }
              { (stock_count != null) &&
                <div className="stock-count">
                  <h6>ストック数</h6>
                  <p className="count">{Utils.viewInt(stock_count)}<span>人</span></p>
                  
                  <h6>フォロワー総数</h6>
                  <p className="followers-count">({Utils.viewInt(stock_followers_count)}<span>人</span>)</p>
                </div>
              }
            </div>
          }
        />
      </div>
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default SearchCommonModal;